import { Fieldset, FormGroup, Link } from "frno-react";
import {
  getPensionProductType,
  PensionProductType,
  PensionProductTypeData,
} from "../../../data/PensionProductType";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import useApplicationStore from "../../../state/ApplicationStore";
import { TablePath, TableType } from "../../../data/TableType";
import useTextStore from "../../../state/TextStore";

type PensionProductTypeSelectorProps = {
  idPrefix: "mobile-" | "desktop-";
};
export default function PensionProductTypeSelector({
  idPrefix,
}: PensionProductTypeSelectorProps) {
  const navigate = useNavigate();
  const { productType } = useParams();
  const { getTextByKey } = useTextStore();
  const { resetState } = useApplicationStore();

  const [selectedValue, setSelectedValue] = useState(
    productType
      ? getPensionProductType(productType)
      : PensionProductType.KAPITALFORSIKRING,
  );

  useEffect(() => {
    setSelectedValue(
      productType
        ? getPensionProductType(productType)
        : PensionProductType.KAPITALFORSIKRING,
    );
  }, [productType]);

  const handleOptionChange = (value: string) => {
    const productType: PensionProductType = value as PensionProductType;

    const productPath = PensionProductTypeData[productType].path;
    resetState();
    navigate(`${productPath}${TablePath[TableType.COMPANIES]}`);
  };

  const options = Object.values(PensionProductType).map(
    (pensionProductType) => ({
      label: PensionProductTypeData[pensionProductType].displayName,
      value: pensionProductType,
    }),
  );

  return (
    <>
      <Fieldset
        className="mb-5"
        legend={
          <span className="fund-type-selector fs-h5">
            {getTextByKey("filter.pensionproducts.header")}
          </span>
        }
      >
        <FormGroup
          id={idPrefix}
          type="radio"
          value={selectedValue}
          options={options}
          onChange={(e) => handleOptionChange(e.target.value)}
          className="mb-4"
        />
      </Fieldset>
      <div className="mt-4">
        <Link
          href="/finansportalen/pensjon/"
          linkText="Les mer om pensjon"
          target="_blank"
        />
      </div>
    </>
  );
}
